import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Data Repo</title>
        <meta
          name="description"
          content="Read the Data Repo Privacy Policy to understand how we collect, use, and protect your personal information when you use our website and software services."
        />
      </Helmet>

      <section className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-[#1E293B] pt-[65px]">
        <h1 className="text-center text-white text-3xl md:text-5xl font-bold uppercase">Privacy Policy</h1>
        <p className="text-center text-white text-lg md:text-xl mt-4 px-6 md:px-0">
          At <strong>Data Repo</strong> (website: <a href="https://datarepo.tech" className="text-blue-600 hover:underline">datarepo.tech</a>), your privacy is very important to us. This Privacy Policy explains how we collect, use, and protect your information.
        </p>
      </section>

      <div className="p-6 sm:p-8 shadow-lg rounded-lg bg-slate-200">
        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">1. Information We Collect</h2>
        <p className="text-gray-700 mb-4">We may collect the following types of information:</p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          <li><strong>Personal Information:</strong> Name, email, phone number, and other contact details you provide when contacting us or using our services.</li>
          <li><strong>Usage Data:</strong> Information about how you use our website and services, including IP address, browser type, pages visited, and access times.</li>
          <li><strong>Cookies & Tracking:</strong> Data collected through cookies and similar technologies to improve your experience and analyze website traffic.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">2. How We Use Your Information</h2>
        <p className="text-gray-700 mb-4">Your information is used for the following purposes:</p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          <li>To provide and maintain our website and services.</li>
          <li>To communicate with you regarding inquiries, updates, or announcements.</li>
          <li>To improve our website, services, and offerings based on feedback and usage.</li>
          <li>To ensure website security and prevent unauthorized access or activities.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">3. Sharing Your Information</h2>
        <p className="text-gray-700 mb-4">We do not sell, rent, or trade your personal information to third parties. We may share your information in the following situations:</p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          <li><strong>With Service Providers:</strong> Trusted third-party partners that help us provide our services (e.g., hosting, analytics), under strict confidentiality agreements.</li>
          <li><strong>Legal Requirements:</strong> When required by law or in response to valid legal requests.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">4. Data Security</h2>
        <p className="text-gray-700 mb-6">
          We implement appropriate technical and organizational measures to protect your information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is completely secure.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">5. Your Rights</h2>
        <p className="text-gray-700 mb-4">You have the right to:</p>
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          <li>Access the personal information we hold about you.</li>
          <li>Request corrections to any inaccurate or incomplete information.</li>
          <li>Request deletion of your information, subject to our legal obligations.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">6. Cookies</h2>
        <p className="text-gray-700 mb-6">
          Data Repo uses cookies to enhance your browsing experience, understand user behavior, and improve website performance. You can manage or disable cookies in your browser settings.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">7. Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mb-6">
          We may update this Privacy Policy from time to time. Updates will be posted on this page with the date of revision. Your continued use of our website after changes indicates your acceptance of the updated policy.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">8. Contact Us</h2>
        <p className="text-gray-700 mb-6">
          If you have any questions about this Privacy Policy or how your information is handled, please visit our
          <a href="/contact-us" className="text-blue-600 hover:underline"> Contact Us</a> page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;